module.exports = __webpack_public_path__ + "static/lights22-bca74907869c7266854acea60610ea5c.jpg";